






import { defineComponent, reactive } from "@vue/composition-api";
import { logout } from "@micad/vue-components";
import { userLogout } from "@/data/repos/userLogout";
import router from "@/router";

export default defineComponent({
  components: {},
  async setup() {
    await userLogout();
    logout(false);
    const returnUrl = router.currentRoute.query.returnUrl || "/";
    console.log("Logout.vue returnUrl", returnUrl);
    window.location.href = returnUrl as string;
    return reactive({});
  },
});
